module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAALFJREFUWEftlrENAjEMRX1r0B5CoqGxB2ADRqFlBBpGYQcGiNMgIdFQUbHEp6I5hdMF+UjzU0aR/9OTbKeTxqdrnC8EoAEaKBowszOATWSLArjlnHfDmmMATxG5BkGsASyrAdx9HwGgqicC0AAN0ECoATPblgZUSulSug8fRKp6F5HVIOzh7v1fAGrH868GFrVBY+8BvCYvI1U9RIZ/arn7cdI6niP8W01+yWiABpobeANhD+Mh3TX0vAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yingJianImg6.png
// module id = Sxzp
// module chunks = 2